
    <app-businesspartnersearch #bpSearch></app-businesspartnersearch>

<div class="row mt-3">

    <div class="col">

        <label *ngIf="!bpHaveData">{{ bpMessage }}</label>

        <label *ngIf="bpHaveData && businessPartnerList.length == 0">No posee información de socios de negocios para mostrar</label>

        <table class="table table-sm" *ngIf="bpHaveData && businessPartnerList.length > 0">
            <thead style="margin-top: 10px;">
                <tr>
                    <th scope="col" width="10%">Código Socio</th>
                    <th scope="col" width="30%">Nombre Socio</th>
                    <th scope="col" width="20%">Fecha Reg.</th>
                    <th scope="col" width="20%">Código RJ</th>
                    <th scope="col" width="10%">Almacén</th>
                    <th scope="col" width="10%">Estado</th>                    
                    <th scope="col" width="10%">Obj Enviado</th>
                </tr>
            </thead>
            <tbody class="tableScroll" style="margin-bottom: 30px;">
                <tr *ngFor="let BP of businessPartnerList">
                    <td width="10%">{{ BP.CardCode }}</td>
                    <td width="30%">{{ BP.CardName }}</td>
                    <td width="20%">{{ BP.CreateDate | date:"dd/MM/yyyy" }}</td>
                    <td width="20%">{{ BP.CodeRJ }}</td>
                    <td *ngIf="BP.Almacen === 'L'" width="10%">Limon</td>
                    <td *ngIf="BP.Almacen === 'C'" width="10%">Caldera</td> 
                    <td *ngIf="BP.Almacen != 'C' && BP.Almacen != 'L'" width="10%">N/A</td>        
                    <td width="10%" class="icono">
                        <span class="fa fa-eye" (click)="ViewBPData(BP.RJResponse, BP.RJResponseDate, BP.RJStatusDetails, BP.ClavisResponse, BP.ClavisResponseDate, contentBP)" placement="left" triggers="mouseenter:mouseleave" ngbPopover="Examinar"></span>                                                
                    </td>
                    <td width="10%" class="icono">
                        <span class=" fa fa-info-circle " (click)="ViewDocDataInfo(BP.ObjSendToRJ, contentDocInfo)" placement="left" triggers="mouseenter:mouseleave" ngbPopover="información"> </span>                                                                      
                    </td>
                </tr>
            </tbody>
        </table>

    </div>

</div>



<ng-template #contentBP let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Detalles</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">       
        <div>
            <p><b>Detalles RJ</b></p>
            <p>{{RJResponseDate}}</p>
            <p>{{RJResponse}}</p>            
            <p>{{RJStatusDetails}}</p>
        </div>
        <div>
            <p><b>Detalles Clavis</b></p>
            <p>{{ClavisResponseDate}}</p>
            <p>{{ClavisResponse}}</p>
            
        </div>               
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cerrar</button>
    </div>
</ng-template>

<ng-template #contentDocInfo let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Obj Enviado</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">       
            <div>
                <pre>{{SendDetails | json}}</pre>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cerrar</button>
        </div>
    </ng-template>